var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.hasCardContent
    ? _c(
        "aside",
        {
          staticClass:
            "information-card d-flex flex-column ga-6 pa-5 rounded-30 bg-gray-0",
          attrs: { "data-qa": "lpu_information_card" },
        },
        [
          _setup.mapSrc
            ? _c(
                "button",
                {
                  staticClass:
                    "information-card__map pa-0 rounded-30 border-sm",
                  attrs: {
                    type: "button",
                    "data-popup-map": _setup.popupMapJson,
                    "data-qa": "lpu_information_map",
                  },
                  on: { click: _setup.handlePopupMapClick },
                },
                [
                  _c("img", {
                    staticClass: "information-card__map-image",
                    attrs: {
                      src: _setup.mapSrc,
                      alt: _setup.mapAlt,
                      loading: "lazy",
                    },
                  }),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex flex-column ga-5" },
            [
              _setup.phone
                ? _c(
                    _setup.InformationField,
                    { attrs: { label: _setup.tStatic("Телефон") } },
                    [
                      _c(
                        "a",
                        {
                          staticClass:
                            "text-subtitle-1 text--text text-decoration-none",
                          attrs: { href: `tel:${_setup.rawPhone}` },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_setup.formattedPhone) +
                              "\n      "
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _setup.mainAddress
                ? _c(
                    _setup.InformationField,
                    { attrs: { label: _setup.tStatic("Адрес") } },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(_setup.tDynamic(_setup.mainAddress, "address"))
                        ),
                      ]),
                      _vm._v(" "),
                      _setup.isStaff && !_setup.isMobile
                        ? _c(
                            "a",
                            {
                              staticClass: "adminka ml-1",
                              attrs: {
                                href: `/admin/doctors/lpuaddress/${_setup.mainAddress.id}/`,
                                target: "_blank",
                                rel: "noopener noreferrer",
                              },
                            },
                            [_vm._v("\n        A\n      ")]
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _setup.metroItems.length
                ? _c(
                    "div",
                    {
                      staticClass: "d-flex flex-column ga-1",
                      attrs: { "data-qa": "metro_list" },
                    },
                    _vm._l(_setup.metroItems, function (metro, index) {
                      return _c(
                        "div",
                        {
                          key: `information-metro-${index}`,
                          staticClass:
                            "d-flex flex-wrap align-center text-body-2 text-secondary--text",
                          attrs: { "data-qa": "metro_item" },
                        },
                        [
                          _c("span", {
                            staticClass:
                              "information-card__metro-color flex-shrink-0 mr-2",
                            style: { backgroundColor: metro.metro.color },
                          }),
                          _vm._v(" "),
                          _c("span", { attrs: { "data-qa": "metro_name" } }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(_setup.tDynamic(metro.metro, "name")) +
                                "\n        "
                            ),
                          ]),
                          _vm._v(" "),
                          metro.walk_time != null
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "d-inline-flex align-center ml-2",
                                },
                                [
                                  _c("span", {
                                    staticClass:
                                      "ui-icon-pedestrian ui-icon-fz-smaller mr-1",
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { attrs: { "data-qa": "metro_distance" } },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            metro.walk_time < 60
                                              ? "1"
                                              : Math.floor(metro.walk_time / 60)
                                          ) +
                                          "\n            " +
                                          _vm._s(_setup.tStatic("мин")) +
                                          "\n          "
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_setup.extraAddresses, function (address) {
                return _c(
                  "div",
                  {
                    key: address.id,
                    staticClass: "text-subtitle-1 text--text",
                  },
                  [
                    _c("span", [
                      _vm._v(_vm._s(_setup.tDynamic(address, "address"))),
                    ]),
                    _vm._v(" "),
                    _setup.isStaff && !_setup.isMobile
                      ? _c(
                          "a",
                          {
                            staticClass: "adminka ml-1",
                            attrs: {
                              href: `/admin/doctors/lpuaddress/${address.id}/`,
                              target: "_blank",
                              rel: "noopener noreferrer",
                            },
                          },
                          [_vm._v("\n        A\n      ")]
                        )
                      : _vm._e(),
                  ]
                )
              }),
              _vm._v(" "),
              _setup.networkName && _setup.networkHref
                ? _c(
                    _setup.InformationField,
                    {
                      attrs: { label: _setup.tStatic("Входит в состав сети") },
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass:
                            "text-subtitle-1 primary--text text-decoration-none",
                          attrs: { href: _setup.networkHref },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_setup.networkName) +
                              "\n      "
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _setup.officialName
                ? _c(
                    _setup.InformationField,
                    {
                      attrs: { label: _setup.tStatic("Официальное название") },
                    },
                    [
                      _vm._v(
                        "\n      " + _vm._s(_setup.officialName) + "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _setup.directorName
                ? _c(
                    _setup.InformationField,
                    { attrs: { label: _setup.tStatic("Руководитель") } },
                    [
                      _vm._v(
                        "\n      " + _vm._s(_setup.directorName) + "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _setup.siteUrl || _vm.licenseItems.length
                ? _c(_setup.InformationActions, {
                    attrs: {
                      "site-url": _setup.siteUrl,
                      "license-items": _vm.licenseItems,
                    },
                  })
                : _vm._e(),
            ],
            2
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }